import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <header className="fixed w-full bg-gradient-to-r from-gray-900 to-gray-800 shadow-lg z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            {!imageError ? (
              <img 
                src="/images/footer-logo.png"
                alt="Pincode Pro Logo" 
                className="h-12 w-auto"
                onError={() => setImageError(true)}
              />
            ) : (
              <span className="text-xl font-bold text-white">Pincode Pro</span>
            )}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.text}
                to={link.href}
                className="text-gray-300 hover:text-white transition-colors font-medium"
              >
                {link.text}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-300 hover:text-white transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-gray-700">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.text}
                  to={link.href}
                  className="text-gray-300 hover:text-white transition-colors font-medium px-2 py-1 rounded hover:bg-gray-700"
                  onClick={() => setIsOpen(false)}
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

const navLinks = [
  { text: 'Home', href: '/' },
  { text: 'About', href: '/about' },
  { text: 'Pincode Lookup', href: '/pincode-lookup' },
  { text: 'Resources', href: '/resources' },
  { text: 'FAQ', href: '/faq' },
  { text: 'Contact', href: '/contact' },
];

export default Header;
